// extracted by mini-css-extract-plugin
module.exports = {"backButton":"RemarkDetailInfo_backButton__1d10z","buttons":"RemarkDetailInfo_buttons__1Qmgz","mr":"RemarkDetailInfo_mr__18G_c"};